import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { LogoMark, Wordmark } from "./Logo";

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="font-display text-lg font-bold text-zinc-100">{title}</h2>
    <div className="mt-3 space-y-3 text-sm sm:text-base leading-relaxed text-zinc-400">
      {children}
    </div>
  </section>
);

export const LegalPage = ({ title, testid, children }) => {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} | FIX ROMA H24`;
    window.scrollTo(0, 0);
    return () => {
      document.title = previous;
    };
  }, [title]);

  return (
    <div
      data-testid={testid}
      className="min-h-screen bg-[#0A0D12] font-body text-zinc-100 antialiased"
    >
      <header className="sticky top-0 z-40 border-b border-white/10 bg-[#0A0D12]/85 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-4xl items-center justify-between px-4 sm:px-6">
          <a
            href="/"
            data-testid="legal-logo-link"
            className="flex items-center gap-3"
            aria-label="FIX ROMA H24 — torna alla home"
          >
            <LogoMark className="h-9 w-9" />
            <Wordmark compact />
          </a>
          <a
            href="/"
            data-testid="legal-back-link"
            className="flex items-center gap-2 text-sm text-zinc-400 transition-colors hover:text-amber-400"
          >
            <ArrowLeft className="h-4 w-4" />
            Torna al sito
          </a>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 py-14 sm:px-6 sm:py-20">
        <p className="font-tech text-xs font-semibold uppercase tracking-[0.3em] text-amber-400">
          FIX ROMA H24
        </p>
        <h1 className="mt-3 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-zinc-50">
          {title}
        </h1>
        <p className="mt-2 text-sm text-zinc-500">
          Ultimo aggiornamento: luglio 2026
        </p>
        <div className="mt-10 space-y-8">{children}</div>
      </main>

      <footer className="border-t border-white/[0.08] py-8 text-center text-xs text-zinc-600">
        © {new Date().getFullYear()} FIX ROMA H24 — Roma e provincia
      </footer>
    </div>
  );
};
